// extracted by mini-css-extract-plugin
export var infoItem = "_ui-2";
export var title = "_ui-0";
export var value = "_ui-1";